module.exports = "<div class=\"jumbotron text-xs-center\">\n    <div style=\"text-align: center\"><i class=\"fa fa-check-circle-o fa-5x\" style=\"color:green\"></i> </div>\n  \n  \n    <div style=\"text-align: center\"><h1 class=\"display-3\">Thank You for payment!</h1></div>\n    <div style=\"text-align: center\"><h3 class=\"display-3\">We are validating your payment, please do not click on back button or refresh the page</h3></div>\n  \n  <hr>\n  <p>\n   \n  </p>\n  <p class=\"lead\">\n    \n  </p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/paymentresponse/paymentresponse.component.html
// module id = ./src/app/paymentresponse/paymentresponse.component.html
// module chunks = main